export default {
  locale_name: '한국어',

  facebook: '페이스북',
  twitter: '트위터',
  insta: '인스타그램',
  telegram: '텔레그램',
  buy: '구매하기',
  sell: '판매하기',
  login: '로그인',
  sign_up: '회원가입',
  profile: '마이페이지',
  logout: '로그아웃',
  home: '홈',
  asset: '자산',
  code: '코드',
  buy_btn: '구매',
  not_allow: '불가',
  sell_btn: '판매',
  trade: '거래',
  select: '선택',
  cancel: '취소',
  deposit: '입금',
  withdraw: '출금',
  request: '신청',
  account: '계좌',
  status: '상태',
  allow: '허용',
  disallowed: '비허용',
  modify: '수정',
  auto: '(자동 입력)',
  inquiry: '조회',
  no_select: '(선택 없음)',
  confirm: '확인',
  upload_btn: '이곳에 파일을 드랍하거나 클릭해 주세요.',
  continue_entry: '계속하시려면 "[+:verification]"를 아래에 입력해 주세요.',

  toasted_msg: {
    confirm: '확인되었습니다',
    changed: '변경되었습니다',
    withdrawal: '탈퇴되었습니다',
    register: '등록되었습니다.',
    title: '알림',
    exchange: '다이렉트 환전이 성공적으로 처리되었습니다.',
    search: '조회되었습니다.',
    deposit_request: '입금 신청 되었습니다.',
    withdraw_request: '출금 신청 되었습니다.',
    create_account: '개설되었습니다.',
    modify: '수정되었습니다.',
    cancel: '취소 되었습니다.',
    trade_confirm: '거래 확정되었습니다.',
    trade_reject: '거래 거부되었습니다.',
    copy: '복사되었습니다.',
    nice_msg:
      '브라우저 설정에서 팝업이 허용되어 있지 않을 경우 본인인증이 정상적으로 진행되지 않습니다.',
    nice_title: '안내',
    nice_error: '본인인증을 할 수 없습니다.',
    no_transfer: '환전정보가 없습니다.',
    email_auth: '이메일 인증이 성공적으로 완료되었습니다.',
    email_auth_send: '인증 메일이 발송되었습니다.',
    kyc_withdraw: '계좌인증에 성공했습니다.',
    not_allow_trade: '거래 비활성화 상태입니다.',
  },
  header: {
    C2C_enroll: 'C2C 등록',
    direct_buy: '즉시구매',
    direct_sell: '즉시판매',
    wallet_manage: '지갑관리',
    C2C_list: 'C2C내역',
    B2C_list: 'B2C내역',
    withdrawal: '입/출금',
    trade_list: '거래내역',
    customer_service: '고객센터',
  },

  home_msg: {
    about_title: 'ABOUT RMT',
    about_title_2: '한국 블록체인 산업의 발전, RMT가 함께합니다.',
    about_line_1_1:
      '가상화폐를 실질적인 현물의 교환 및 중계소의 형태의 신개념 가상화폐 중계소',
    about_line_1_2: '검증된 암호화폐 엄선하여 상장',
    about_line_1_3: '다양한 언어를 지원하는 글로벌 암호화폐 중계소',
    about_line_2_1:
      '대규모분산형아키텍쳐 설계 및 DDOS 공격 방어 시스템을 바탕으로 안심할 수 있는 보안성',
    about_line_2_2: '안정적인 거래환경 및 자산 보완 관리 솔루션 제공',
    about_line_3_1: '자체 네트워크를 통해 결제 및 거래 안정성 확보',
    about_line_3_2: '고객과 신뢰 관계를 구축하고 주기적인 서비스 업데이트',
    about_line_4_1:
      '온라인과 오프라인의 제약 없이 암호화된 자산을 활용할 수 있도록 연결하는 통합된 크립토 플랫폼',
    about_sub_1: '핵심',
    about_sub_1_1:
      '글로벌 규제가 강화해 져가는 추세에 맞게 국제기구인 FATF (Financial Action Task Forc)와 가상자산서비스제공업체(VASP : virtual Asset Service Providers)의 권고안에 따른 자금 세탁 방지와 테러자금조달차단 규정 준수',
    about_sub_1_2:
      '암호화폐 보유자들이 장외거래(OTC)의 비중이 늘고 있고 신뢰할 수 있는 거래소의 신뢰성 저하에 맞추어 C2C B2C 같은 즉시거래 지원',
    about_sub_2: '다양한컨텐츠',
    about_sub_2_1:
      '키오스크를 활용하여 오프라인 어디에서든 사용 가능하게 접근성을높힘',
    about_sub_2_2: '카드형 지갑을 만들 수 있어서 안전성과 편의성의 극대화',
    about_sub_2_3: '글로벌 오픈 마켓 쇼핑몰 운영',
    about_sub_3: '글로벌 비전',
    about_sub_3_1:
      '한국을 넘어 중국 및 동남아 서비스와 일본,유럽서비스 확산 예정',
    about_sub_3_2:
      '국내에 도입한 키오스크 기기를 베트남, 필리핀 등 해외에 보급하여 새로운 시대를 주도하는 글로벌 암호화폐 중계소 RMT',
    about_side_1: '세계를 선도하는 암호화폐 거래소',
    about_side_1_1:
      '신속하고 안전하게 직거래할 수 있는(C2C) 24시간 거래 서비스 지원',
    about_side_1_2:
      '에스크로시스템를 서비스 하여 암호화폐 거래 진행 안전성 제공',
    about_side_1_3:
      '중간단계 없이 RMT를 이용해 퀵(Quick) 거래가 가능한 B2C 지원',
    about_side_1_4:
      'OTC(장외거래)의 번거로움과 수수료 부담을 줄여주며 오프라인에서도 24시간 안전하고 간편한 직거래 서비스 지원',
    login_register: '로그인/회원가입',
    trade_guide: '거래 가이드 보기',
    app_down_1: 'App 다운로드',
    app_down_2: '다양한 코인,실시간 시세,간편 거래',
    app_down_3: '언제 어디서나 편리한 거래 서비스를 이용할 수 있습니다',
  },
  footer: {
    about: '소개',
    career: '연혁',
    escrow: '에스크로 거래',
    press: '언론',
    partner: '우리와 파트너가 되려면',
    help: '고객지원',
    chat: '라이브챗',
    blog: '블로그',
    phone: '연락번호',
    social: '소셜',
  },
  footer_link: {
    about_title: '회사소개',
    msg_about_1:
      'RMT는 Real Money Trade의 약자로 가상화폐 중계소 입니다. 글로벌 규제가 강해지고 있는 추세에 맞게 국제기구인 FATF (Financial Action Task Force)와 가상자산서비스제공업체VASP (Virtual Asset Service Providers)의 권고안에 따른 자금 세탁 방지와 테러자금조달차단 규정을 준수하고 있으며 사용자들의 원활한 거래와 안전한 거래를 서포트 해주고 있습니다. ',
    msg_about_2:
      '암호화폐 보유자들은 장외거래(OTC)에 비중을 두고 있으며 거래소들의 신뢰성이 저하되고 있습니다. 변하고 있는 시대에 맞추어 RMT는 C2C B2C와 같은 즉시거래를 지원하고 있습니다.',
    msg_about_3:
      'RMT의 ONE CARD는 콜드 월렛 시스템을 결합하여 네트웍이 차단된 하드웨어 장치에 가상화폐를 보관하고 오프라인에서 처리해 보안성이 뛰어납니다.',
    msg_about_4:
      'ONE CARD는 국내에 보급된 키오스크 기기에 사용할 수 있으며 오프라인에서도 RMT 중계소를 이용할 수 있습니다',
    msg_about_5:
      '또한 키오스크 기기는 현금 인출 및 입금, 영화표 예매, RMT 쇼핑몰 등 현실성 있는 다양한 컨텐츠를 누리게 해드립니다.',
    msg_about_6:
      'RMT는 영어, 중국어, 일본어 등 다양한 언어를 지원하고 있으며 국내뿐만 아닌, 해외까지 키오스크 기기를 보급하여 시대에 걸 맞는 전자금융 트랜드를 주도할 것입니다.',
    escrow_big_title: '에스크로 거래',
    msg_escrow_1:
      '에스크로 서비스란 판매자와 구매자 간의 거래가 안전하고 원활하게 이뤄질 수 있도록 해주는 자산보호 서비스입니다.',
    msg_escrow_2: '-거래절차-',
    msg_escrow_3: '1. 회원이 KRW를 충전하면 원화를 은행(PG사)에 보관해 둡니다.',
    msg_escrow_4:
      '2. 충전한 회원이 구매를 요청하면 은행(PG 사)에 맡긴 돈으로 판매자에게 입금합니다.',
    msg_escrow_5:
      '3. 판매자는 돈을, 구매자는 코인을 확인하면 거래가 성립됩니다.',
    msg_escrow_6:
      '4.문제가 발생할 경우, 양측이 제공한 증거에 근거하여 해결합니다.',
    msg_escrow_7: 'RMT는 회원님의 자산보호를 위해 노력합니다.',
  },
  account_form: {
    id_place: '아이디를 입력하세요',
    pw_place: '비밀번호를 입력하세요',
    forgot_pw: '비밀번호를 잊으셨나요?',
    confirm_pw: '비밀번호 확인',
    name_place: '이름을 입력하세요',
    email_place: '이메일을 입력하세요',
    agree: '동의 합니다.',
    all_agree: '모두 동의 합니다.',
    find_pw: '비밀번호 찾기',
    code_place: '발송된 코드를 입력하세요',
  },
  trade_page: {
    b2c_trade: 'B2C 거래하기',
    select_asset: '자산을 선택해주세요',
    select_coin: '코인을 선택해주세요',
    c2c_trade: 'C2C 거래하기',
    buy_asset: '구입 할 자산',
    sell_asset: '판매 할 자산',
    purchaser_name: '구매자명',
    seller_name: '판매자명',
    amount: '수량',
    limit_buy: '최소 구매 수량',
    limit_sell: '최소 판매 수량',
    total_sell_price: '총 판매 수량',
    buy_price: '구매가격',
    sell_price: '판매가격',
    regdate: '최종정보수정일',
    sell_register: '판매등록',
    buy_register: '구매등록',
    select_c2c_info: '선택한 매도 공시 정보',
    seller_info: '판매자 정보',
    market_select: '마켓 선택',
    market_title: '마켓명',
    sell_price_msg: '판매하고자 하는 수량 (0.00000000)',
    min_sell_amount: '최소 판매 수량',
    min_buy_price: '최소 구입 수량',
    min_sell_amount_msg: '상대방의 최소 구입 개수',
    per_sell_price: '개당 판매 가격',
    per_sell_price_msg: '1.00000000 개의 지정된 가격을 정하세요.',
    per_sell_price_msg2: '판매 수량 1개당 받고 싶은 가격을 정하시면 됩니다.',
    select_account: '받을 계좌 선택',
    withdraw_account: '출금 계좌 선택',
    direct_buy_asset: '즉시 구입 할 자산',
    direct_sell_asset: '즉시 판매 할 자산',
    change_target_asset: '교체 대상 자산',
    source_buy_asset: '구입 자산',
    source_sell_asset: '판매 자산',
    target_change_asset: '교체 자산',
    b2c_buy_price: '구입가격',
    b2c_sell_price: '판매가격',
    buy_amount: '구입 수량',
    sell_amount: '판매 수량',
    buy_amount_msg: '구입하고자 하는 수량 0.00000000',
    per_price: '개당 가격',
    per_price_msg: '보유 {0} :',
    per_price_msg2: '자동으로 가격이 노출 됩니다.',
    receive_quantity: '수령 수량',
    bill_amount: '지불 해야할 수량',
    b2c_buy_title: '구매합니다.',
    b2c_sell_title: '판매합니다.',
    b2c_asset: '{0} 를 {1} 로',
    b2c_market_price: '현 시세',
    b2c_direct_buy: '즉시 구매 시',
    b2c_direct_sell: '즉시 판매 시',
    b2c_exchange_amount: '환전 수량',
    b2c_amount: '적용 수량',
    b2c_buy: '{0} 로 구매',
    b2c_sell: '{0} 로 판매',
    potential_amount: '가용 수량',
    holding_amount: '미확정 판매 수량',
    confirm_amount: '확정 판매 수량',
  },
  page_navigation: {
    first_page: '첫 페이지',
    last_page: '끝 페이지',
  },
  wallet: {
    asset_value: '내 KRW 보유 양',
    show_currency: '모든 자산 보기',
    asset_list: '자산 목록',
    wallet_list: '계좌 목록',
    account_name: '계좌 이름',
    account_number: '계좌번호',
    balance: '잔액',
    withdrawal_register: '입/출금 신청',
    withdrawal_inquiry: '입/출금 신청 조회',
    account_register: '계좌생성',
    deposit_inquiry: '입금 조회',
    withdraw_inquiry: '출금 조회',
    account_modify: '계좌수정',
    deposit_price: '입금 금액',
    deposit_register: '입금 신청',
    withdraw_register: '출금 신청',
    withdraw_price: '출금 금액',
    account_seq: '계좌 고유 번호',
    regdate: '개설일',
    hold_balance: '정지금액',
    selected_asset: '선택 자산',
    before_regdate: '(개설전)',
    open: '개설',
    address_title: '계좌 주소 정보',
    account_address: '계좌 주소',
    create_account_address: '계좌주소개설',
    deposit_msg: '외부 지갑으로부터 나의 {0}지갑으로 {0}를 입금합니다.',
    deposit_msg_1:
      '블록체인 상에서 350번의 승인(컨펌)을 받은 후 {0} 거래 지갑에 반영됩니다.',
    deposit_step_1: 'STEP 1. {0} 메모 ID를 먼저 확인해 주십시오.',
    deposit_step_1_1: '나의 {0} 메모 ID',
    deposit_step_1_2:
      '{0} 입금 시 고객님의 고유 메모 ID를 반드시 표기해야 합니다. 메모 ID 없이 송금된 {0}는 유실됩니다.',
    deposit_step_1_3: '확인하였습니다. 내 {0} 지갑 주소를 봅니다.',
    deposit_step_1_btn: '메모 ID 생성',
    deposit_step_2: 'STEP 2. 내 지갑 주소를 확인해 주십시오.',
    deposit_step_2_1: 'QR 코드',
    deposit_step_2_2: '지갑주소',
    deposit_step_2_3:
      '최소 입금 금액은 <span style="color:#4a90e2">{0} {1}</span> 입니다.',
    deposit_step_2_btn: '지갑주소 복사',
    deposit_msg_2: '확인해 주십시오',
    deposit_msg_2_1: '위 주소는 입금 전용 주소입니다.',
    deposit_msg_2_2:
      '컨펌 완료에 소요되는 총 시간은 블록체인 네트워크의 혼잡도에 따라 영향을 받을 수 있으며, 암호화폐별 블록체인 혼잡도는  <span style="color:#4a90e2;cursor:pointer;">여기</span>에서 확인하실 수 있습니다.',
  },
  private: {
    my_deal_list: '내 판매 목록',
    my_app_list: '내 구매 내역',
    source_asset: '원 자산',
    target_asset: '대상 자산',
    source_amount: '원 자산 수량',
    regdate: '공시일',
    source_max_amount: '최대 수량',
    source_min_amount: '최소 수량',
    max_price: '최대 호가 제한',
    min_price: '최소 호가 제한',
    close_date: '종결일',
    app_inquiry_cancel: '구매 내역 조회/취소',
    app_name: '매수자 명',
    per_price: '수량 당 가격',
    confirm_reject: '확정/거부',
    confirm: '확정',
    reject: '거부',
    fee_amount: '수수료 합계',
    request_cancel: '신청취소',
    b2c_source_asset: '기준 자산',
    b2c_target_asset: '상대 자산',
    b2c_source_amount: '기준 자산 수량',
    b2c_target_amount: '상대 자산 수량',
    basic_rate: '적용 매매기준율',
    spread_rate: '적용 스프레드율',
    exchange_rate: '적용 환율',
    source_account: '기준 자산 계좌 번호',
    target_account: '상대 자산 계좌 번호',
    fee_rate: '수수료',
    fee_calc: '{0} 개 만큼 차감됩니다.',
    b2c_buy_asset: '구매 자산',
    b2c_sell_asset: '판매 자산',
    b2c_buy_amount: '구매 자산 수량',
    b2c_sell_amount: '판매 자산 수량',
    b2c_last_buy_amount: '최종 구매 가격',
    b2c_last_sell_amount: '최종 판매 가격',
  },
  withdrawal: {
    deposit_list: '입금 신청 내역',
    withdraw_list: '출금 신청 내역',
    asset_name: '자산 명',
    request_price: '요청 금액',
    deposit_inquiry_cancel: '입금 내역 조회/취소',
    withdraw_inquiry_cancel: '출금 내역 조회/취소',
    history_detail: '내역 상세',
    regdate: '신청일',
  },
  myprofile: {
    profile: '회원 정보',
    user_name: '유저명',
    email: '이메일',
    regdate: '가입일',
    last_login: '최근 로그인',
    kyc_cert: 'KYC 인증',
    kyc_cert_request: '인증신청',
    kyc_cert_list: '신청내역',
    pw_modify: '비밀번호 수정',
    old_pw: '기존 비밀번호를 입력하세요',
    new_pw: '새로운 비밀번호를 입력하세요',
    confirm_pw: '비밀번호 확인',
    email_modify: '이메일 수정',
    new_email: '새로운 이메일을 입력하세요',
    withdrawal: '계정 탈퇴',
    modal_msg: '탈퇴 하시려면 비밀번호를 입력하세요',
    authority: '본인인증',
    complete_auth: '인증 완료',
    authenticate: '인증하기',
    uid: '회원번호(UID)',
    email_auth: '이메일 인증',
    auth: '인증',
    auth_code_send: '인증 코드 발송',
    auth_code: '인증코드',
    auth_code_msg: '인증코드를 5분 이내에 입력해 주세요.',
    otp_auth: 'OTP 인증',
    enroll: '등록하기',
    security: '보안등급',
    security_view: '보안등급보기',
    withdraw_auth: '출금주소인증',
  },
  kyc: {
    kyc_title: 'KYC인증',
    regdate: '등록일',
    expdate: '만료일',
    detail: '상세',
    type_title: '유형명',
    withdraw_auth: '출금 주소 인증',
    select_asset: '자산 선택',
    select_bank: '은행 선택',
    holder_name: '예금주 명',
    birth: '생년월일 6자리',
    address: '자산 주소',
    withdraw_list: '출금계좌 신청내역',
    bank_name: '은행 명',
    withdraw_info: '출금 계좌 정보',
    withdraw_complete: '이미 인증이 완료된 자산입니다.',
  },
  otp: {
    enter_verification_number: 'OTP 인증 번호를 입력하세요',
    otp_management: 'OTP관리',
    authenticode: 'OTP키',
    otp_deactivate: 'OTP비활성화',
    msg_authenticator_installation:
      '"Google Authenticator" 앱을 스마트폰 또는 데스크톱에 설치해 주세요',
    android: '안드로이드 ',
    or: '또는 ',
    iphone_series: '소hone, iPad 그리고 iPod',
    windows_phone: ' Windows Phone',
    and: ', 그리고',
    msg_microsoft_other_systems:
      'Microsoft Windows desktop을 포함한 기타 다른 시스템',
    msg_key: '이 키를 ',
    msg_use_loss_change:
      ' 종이에 적어 주세요. 단말을 잃어버리거나 OTP를 변경해야 할 때 사용됩니다.',
    msg_brcode_touch:
      '"Google Authenticator" 앱을 실행하시고 화면 아래의 <b>Scan QR barcode</b>을 탭해 주세요.',
    msg_input_authenticode:
      '단말의 화면에 표시된 인증코드를 아래의 "인증코드" 란에 입력해 주세요.',
    otp_key: 'OTP 키',
    otp_activate: 'OTP 활성화',
    otp_copy: 'OTP 키가 복사되었습니다.',
    otp_safe_keeping: 'OTP키를 종이에 적은 후 안전한 곳에 보관하셨습니까?',
    yes: '네',
    otp_register: '등록',
    otp_register_success: 'OTP 등록이 성공적으로 완료되었습니다.',
    otp_delete_success: 'OTP 말소 등록이 성공적으로 완료되었습니다.',
    msg_click_key_copy: '클릭하시면 키가 복사됩니다.',
    otp_login: 'OTP 로그인',
  },
  security: {
    security_auth: '보안인증',
    grade: '등급',
    condition: '조건',
    restriction: '제한 사항',
    no_grade: '무등급',
    no: '없음',
    security_title: '보안 등급별 조건별 제한사항',
  },
  notice_modal: {
    title: '공지사항',
    content:
      '고객의 자산을 소중히 생각하는 RMT 입니다. 원활한 거래 안정을 위하여 회원가입만을 먼저 진행할것이며 거래개시 일은 추후 공지를 통하여 고객분들께 공지 할것입니다 감사합니다',
    check: '하루 동안 보지않기',
  },
  admin: {
    search: '검색',
    search_word: '검색어',
    sort: '정렬',
    desc: '내림차순(DESC)',
    asc: '올림차순(ASC)',
    reset: '초기화',
    submit: '제출',
    regdate: '등록일',
    last_login: '최근로그인',
    search_target: '검색대상',
    user_id: '아이디',
    email_address: '이메일주소',
    user_name: '이름',
    member_seq: '회원고유번호',
    regdate_more: '가입일(이상)',
    regdate_less: '가입일(이하)',
    last_login_more: '최근 로그인(이상)',
    last_login_less: '최근 로그인(이하)',
    no_data: '없음',
    inviter_user_id: '추천자 아이디',
    show_inviter_list: '피추천자 보기',
    num: '번호',
    password: '비밀번호',
    security_level: '보안 등급 레벨 값',
    loading: '데이타를 불러오는 중입니다...',
    ipaddress: '아이피 주소',
    user_agent: '단말 정보',
    login_log_regdate_more: '등록일(이상)',
    login_log_regdate_less: '등록일(이하)',
    result: '결과',
    total: '전체',
    no_search_login: '검색된 로그인 내역이 없습니다.',
    status: '상태',
    all_show: '전체보기',
    market_title: '마켓명',
    deal_source_amount: '공시 원자산 수량',
    deal_confirmed_source_amount: '확정 원자산 수량',
    deal_source_max_amount: '최대 매수 수량',
    deal_max_price: '최대 호가',
    source_asset_title: '원자산',
    deal_holding_source_amount: '대기 원자산 수량',
    deal_potential_source_amount: '가용 원자산 수량',
    deal_source_min_amount: '최소 매수 수량',
    deal_min_price: '최소 호가',
    target_asset_title: '대상자산',
    source_account: '원자산 계좌',
    app_account: '매수 계좌',
    fee: '수수료',
    source_amount: '원자산 수량',
    deal_account: '매도 계좌',
    app_price: '지분 금액',
    close_date: '종결일',
    no_limit: '(무제한)',
    no_close: '(미종결)',
    no_search_deal: '검색된 C2C 매도 공시 내역이 없습니다.',
    no_search_app: '검색된 C2C 매수 요청 내역이 없습니다.',
    transfer_type: '환전 유형',
    transfer_asset_pair: '자산쌍',
    basic_rate: '적용 매매기준율',
    transfer_source_asset_title: '기준 자산',
    transfer_source_account: '기준 자산 계좌',
    exchange_rate: '적용 환율',
    transfer_source_amount: '기준 자산 수량',
    transfer_target_asset_title: '상대 자산',
    transfer_target_account: '상대 자산 계좌',
    spread_rate: '적용 스프레드율',
    transfer_target_amount: '상대 자산 수량',
    no_search_transfer: '검색된 환전 내역이 없습니다.',
    confirm_delete: '정말로 삭제하시겠습니까?',
    modal_confirm: '확인',
    c2c_market: 'C2C 시장 관리',
    market_source_min_amount: '원자산 최소 수량',
    market_source_max_amount: '원자산 최대 수량',
    market_fee_rate: '수수료율',
    market_source_amount_unit: '원자산 단위 제한',
    is_active: '활성 여부',
    market_no_limit: '(제한없음)',
    more_zero: '0 이상',
    no_use_cover: '(사용안함)',
    add: '추가',
    modify: '수정',
    no_c2c_market: '등록된 C2C 시장이 없습니다.',
    direct_transfer_market: '환전(즉시 매입/매도) 시장 관리',
    direct_basic_rate: '매매기준율',
    direct_bid_spread_rate: '매입 스프레드율',
    direct_allow_bid: '매입 거래 허용',
    direct_ask_spread_rate: '매도 스프레드율',
    direct_allow_ask: '매도 거래 허용',
    no_direct_market: '등록된 환전 시장이 없습니다.',
    b2c_market: 'B2C 시장 관리',
    asset_manage: '자산 관리',
    asset_title: '자산명',
    asset_code: '코드',
    modal_asset_code: '자산 코드',
    asset_decimal: '소숫점 자릿수',
    allow_deposit: '입금 허용',
    allow_withdraw: '출금 허용',
    delete: '삭제',
    no_asset: '등록된 자산이 없습니다.',
    asset_plugin: '자산 플러그인',
    plugin_title: '플러그인 제목',
    plugin: '플러그인',
    plugin_select: '플러그인 선택',
    start_block: '시작 블럭',
    allow_scan: '스캔 허용',
    no_asset_plugin: '등록된 자산 플러그인이 없습니다.',
    c2c_market_modify: 'C2C 마켓 수정',
    c2c_market_enroll: 'C2C 마켓 등록',
    direct_market_modify: '환전 시장 수정',
    direct_market_enroll: '환전 시장 등록',
    asset_modify: '자산 수정',
    asset_enroll: '자산 등록',
    asset_plugin_modify: '자산 플러그인 수정',
    asset_plugin_enroll: '자산 플러그인 등록',
    default_info: '기본 정보',
    auto: '(자동입력)',
    before_enroll: '(등록전)',
    c2c_market_seq: 'C2C 마켓 고유 번호',
    c2c_market_regdate: '최초 등록일',
    c2c_market_title: 'C2C 마켓명',
    c2c_source_amount_unit: '원자산 단위',
    save: '저장',
    enroll: '등록',
    deal_form: '매도자 추가 작성 양식',
    msg_save: '저장하시겠습니까?',
    msg_enroll: '등록하시겠습니까?',
    msg_c2c_modify: 'C2C 마켓이 수정되었습니다.',
    msg_c2c_enroll: 'C2C 마켓이 신규 등록되었습니다.',
    modal_is_active: '활성',
    allow: '제한함',
    not_allow: '제한안함',
    form_info_add: '양식 추가',
    form_info_title: '양식 제목',
    form_info_list_order: '출력 순서',
    form_info_description: '양식에 대한 간단한 설명을 입력해 주세요.',
    field_info_name: '입력 공간 이름',
    field_info_title: '입력 공간 제목',
    field_info_description: '입력 공간 설명',
    field_info_is_editable: '수정 가능',
    field_info_type: '입력 공간 유형',
    field_info_select: '선택지 모음 / 확장자',
    field_info_no_space: '빈공간 대체 문자열',
    field_info_is_required: '필수',
    field_info_extension_place: '지원 확장자를 콤마(,)로 구분하여 입력',
    no_target: '(대상 아님)',
    no_field: '등록된 입력 공간이 없습니다.',
    lang_search_select: '다국어 검색 및 선택',
    content: '내용',
    locale: '로캘',
    new_enroll: '신규 등록',
    enroll_lang: '등록된 다국어',
    value: '값',
    no_lang: '등록된 다국어 항목이 없습니다.',
    lang_item_name: '영문+숫자(첫글자 영문)',
    msg_optionset_delete: '정말로 선택지 모음을 삭제하시겠습니까?',
    no_optionset: '선택지 모음 미지정',
    yes_optionset: '(선택지 모음 지정)',
    optionset_add: '추가하려면 <i class="el-icon-plus"></i> 버튼 클릭',
    optionset_manage: '선택지 모음 관리',
    title: '제목',
    title_admin_place: '관리자용 제목을 입력해 주세요.',
    description: '설명',
    description_admin_place: '관리자용 설명을 입력해 주세요.',
    optionset: '선택지',
    optionset_name: '값이름',
    msg_direct_market_modify: '환전 시장이 수정되었습니다.',
    msg_direct_market_enroll: '환전 시장이 신규 등록되었습니다.',
    direct_market_seq: '환전 시장 고유 번호',
    msg_asset_modify: '자산이 수정되었습니다.',
    msg_asset_enroll: '자산이 신규 등록되었습니다.',
    deposit_form: '입금자 추가 작성 양식',
    withdraw_form: '출금자 추가 작성 양식',
    msg_plugin_modify: '자산 플러그인이 수정되었습니다.',
    msg_plugin_enroll: '자산 플러그인이 신규 등록되었습니다.',
    asset_plugin_seq: '자산 플러그인 고유 번호',
    asset_plugin_name: '자산 플러그인명',
    asset_plugin_start_block: '시작 블럭 번호',
    msg_denied: '거부하시겠습니까?',
    msg_denied_success: '거부 처리되었습니다.',
    msg_approve: '승인하시겠습니까?',
    msg_approve_success: '승인 처리되었습니다.',
    approve: '승인',
    denied: '거부',
    no_search_cdd: '검색된 CDD 증명 요청 내역이 없습니다.',
    kyc_type: '증명 유형',
    kyc_cdd: 'CDD 증명 요청 내역',
    type: '유형',
    kyc_is_valid: '유효 여부',
    valid: '유효',
    invalid: '무효',
    kyc_expdate: '만기일',
    no_appoint: '(미지정)',
    kyc_cdd_detail: 'CDD 증명 요청 상세',
    kyc_cdd_name_id: '이름(아이디)',
    real_name: '실명 인증 이름',
    di: '중복가입 확인값',
    ci: '연계정보 확인값',
    nationality: '국적',
    search_is_valid: '유효만 검색',
    yes: '예',
    real_name_list: '실명인증 내역',
    authority: '인증 기관',
    cell_carrier: '통신사',
    sex: '성별',
    ip_address: 'IP 주소',
    cell_number: '전화번호',
    no_search_real_name: '검색된 실명인증 내역이 없습니다.',
    kyc_withdraw_list: '자산 출금 주소 증명 내역',
    bank: '은행',
    holder_name: '소유자명',
    withdraw_address: '출금 주소',
    no_search_kyc_withdraw: '검색된 자산 출금 주소 증명 내역이 없습니다.',
    restriction_manage: '제한 정책 관리',
    restriction_list_order: '검사 우선 순위',
    restriction_level: '등급 구간',
    restriction_title: '제한 정책명',
    no_restriction: '등록된 제한 정책이 없습니다.',
    level_manage: '등급 관리',
    level_list_order: '순서',
    level: '등급',
    level_title: '등급명',
    no_level: '등록된 등급이 없습니다.',
    restriction_modify: '제한 정책 수정',
    restriction_enroll: '제한 정책 등록',
    level_modify: '등급 수정',
    level_enroll: '등급 등록',
    msg_restriction_modify: '제한 정책이 수정되었습니다.',
    msg_restriction_enroll: '제한 정책이 신규 등록되었습니다.',
    msg_delete: '삭제되었습니다.',
    msg_save_success: '저장되었습니다.',
    msg_enroll_success: '등록되었습니다.',
    restriction_target: '제한 대상',
    restriction_apply: '아래의 제한 정책을 적용함',
    restriction_select: '== 선택 ==',
    no_restriction_target: '등록된 제한 대상이 존재하지 않습니다.',
    msg_level_modify: '등급이 수정되었습니다.',
    msg_level_enroll: '등급이 신규 등록되었습니다.',
    msg_level_condition: '아래 조건을 모두 충족해야함',
    no_level_condition: '등록된 조건이 존재하지 않습니다.',
    restriction_target_list: {
      NONE: '{0}',
      CREATE_ACCOUNT: '{0} {1}',
      LIMIT_ASSET_WITHDRAW_ONE_TIME_AMOUNT: '{0}을 {1}로 {2}',
      LIMIT_ASSET_WITHDRAW_DAILY_AMOUNT: '{0}을 {1}로 {2}',
    },
    level_condition_list: {
      NONE: '{0}',
      KYC_CERTIFICATION: '{0}의 {1}를 완료하여야함',
      KYC_REALNAME: '{0}을 하여야함',
      KYC_ASSET_WITHDRAW_ADDRESS_CERTIFICATION: '{0}을 {1}로 완료하여야함',
      MAIL_VERIFICATION: '{0}을 하여야함',
      OTP_REGISTER: '{0}을 하여야함',
    },
    kyc_certification_type_info: {
      N: '{0}',
      Y: '{0}하고 {1}초 동안 유효하게 함',
    },
    account_info: '계좌 정보',
    account_enroll: '계좌 등록',
    deposit_address: '입금 전용 주소',
    excel_download: '현재결과 엑셀 다운로드',
    new_account: '+ 계좌 신규',
    private_key_copy: '개인키 복사',
    no_search_account: '검색된 계좌가 없습니다.',
    msg_account: '개설하시겠습니까?',
    msg_account_modify: '계좌 수정되었습니다.',
    msg_account_open: '계좌 신규 개설되었습니다.',
    request_amount: '신청 금액',
    no_search_deposit: '검색된 입금 내역이 없습니다.',
    no_search_withdraw: '검색된 출금 내역이 없습니다.',
    deposit_detail: '입금 신청 상세',
    withdraw_detail: '출금 신청 상세',
    withdraw_certification: '인증 출금 정보',
    service_msg: '서비스 이용에 필수적인 설정을 할 수 있습니다.',
    token_secret: '토큰 서명 키',
    token_lifetime: '토큰 유효기간',
    default_locale: '기본 로캘',
    support_locale: '지원 로캘',
    page_display: '페이지 노출',
    use_signup: '회원가입 사용',
    is_required: '필수동의',
    valid_time: '유효 시간',
    sec: '초',
    no_kyc_type: '등록된 KYC 증명 유형이 없습니다.',
    real_name_setting: '실명 인증 설정',
    msg_real_name_setting: '본인인증 및 실명인증 관련 설정을 합니다.',
    real_name_authority: '실명 인증 기관',
    no_real_name_authority: '실명 인증 사용 안함',
    site_code: '사이트 코드',
    site_pw: '사이트 PW',
    exec_path: '실행 경로',
    kyc_type_modify: 'KYC 증명 유형 수정',
    kyc_type_enroll: 'KYC 증명 유형 등록',
    msg_kyc_type_modify: 'KYC 증명 유형이 수정되었습니다.',
    msg_kyc_type_enroll: 'KYC 증명 유형이 신규 등록되었습니다.',
    kyc_type_title: 'KYC 증명 유형명',
    kyc_type_name: 'KYC 증명 유형 이름',
    cdd_valid_time: 'CDD 유효 기간',
    use: '사용',
    no_use: '사용 안함',
    kyc_form: '작성 양식',
    mail_setting: '메일 설정',
    msg_mail_setting: '메일 발송 시 사용될 정보를 설정합니다.',
    default_sender: '기본 발신자',
    mail_service: '메일 서비스',
    msg_mail_service: '메일 발송 여부 및 서비스 제공자별 설정을 합니다.',
    provider: '서비스 제공자',
    no_send_mail: '메일 발송 안함',
    provider_domain: '도메인',
    provider_api_key: 'API 키',
    msg_fake:
      '제공자를 지정한 것과 동일하게 동작하고 메일 발송내역에 기록은 되나 실제로 발송하지는 않습니다.',
    alert_setting: '알림 설정',
    customer_alert: '고객 (HTML 사용가능)',
    admin_alert: '관리자 (HTML 사용가능)',
    replacer: '치환자',
    manager: '대상 관리자',
    otp_setting: 'OTP 설정',
    msg_otp_setting: 'OTP 사용과 관련된 설정을 합니다.',
    allow_disable_otp: 'OTP 말소 허용',
    max_otp_count: 'OTP 최대 등록 갯수',
    otp_available_actions: '적용 행동',
    first_page: '첫 페이지',
    last_page: '끝 페이지',
    cmd_admin_page: '관리자',
    cmd_brokerage_page: '마스터',
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_balance_adjustment_ask:
      '정말로 계좌 잔액 강제 조정을 실행하시겠습니까?',
    msg_balance_adjustment_succeed:
      '잔액 강제 조정이 성공적으로 처리되었습니다.',
    price_change: '잔액변동내역',
    balance_adjustment: '잔액 강제 조정',
    msg_balance_forced_adjustment_info:
      '시스템 오류, 테스트 및 사기로 인한 잔액 회수 등 잔액을 강제로 조정해야 하는 경우에 사용하실 수 있습니다.',
    msg_balance_forced_adjustment_responsibility:
      '잔액 강제 조정 기능을 악용하거나 권한이 없는자가 임의로 사용할 경우 민/형사적 책임이 부과될 수 있습니다.',
    msg_balance_forced_adjustment_error:
      '잔액 강제 조정 후 예상치 못한 오류가 발생할 수 있습니다.',
    msg_balance_forced_adjustment_carefully:
      '실행 후 사유 정보를 변경하실 수 없으니 신중히 입력하시기 바랍니다.',
    adjustment_amount: '조정 금액',
    increase: '증가',
    deduction: '차감',
    reason: '사유',
    execution: '실행',
    use_statistics_exclude: '통계 제외 회원 제외',
    connect: '연결 대상',
    all: '전체',
    connection_number: '연결 대상 고유번호',
    change_history: '잔액 변동 내역',
    performer: '실행자',
    perfor_ip: '실행 IP',
    case_name: '사건명',
    occurrence_date: '발생일',
    before_change: '변동 전 잔액',
    after_change: '변동 후 잔액',
    explanation: '설명',
    car: '차',
    system: '시스템',
    not_recorded: '기록되지않음',
    msg_searched_change: '검색된 잔액 변동 내역이 없습니다.',
    account_update_balance_bulk: '계좌 잔액 대량 직권 정정',
    msg_excel_warning:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    msg_accountopen: '계좌를 정상처리하시겠습니까?',
    msg_accountopen_success: '계좌 정상처리에 성공했습니다.',
    msg_accountfraud: '계좌를 사기처리하시겠습니까?',
    msg_accountfraud_success: '계좌 사기처리에 성공했습니다.',
    member_is_alive: '탈퇴 회원 제외',
    normal: '정상',
    fraud: '사기',
    account_detail: '계좌 상세',
    as_list: '목록으로',
    from_use_statistics_exclude: '통계 제외 출금 계좌 회원 제외',
    to_use_statistics_exclude: '통계 제외 입금 계좌 회원 제외',
    from_member_is_alive: '탈퇴한 출금 계좌 회원 제외',
    to_member_is_alive: '탈퇴한 입금 계좌 회원 제외',
    msg_search_transfer_list: '검색된 이체 내역이 없습니다.',
    transfer_list: '이체 내역',
    role: '역할',
    select: '선택',
    msg_grant_roles: '등록된 권한별 역할이 없습니다.',
    endpoint: '종단점',
    endpoint_select: '종단점 선택',
    use_script: '스크립트 사용',
    target: '대상',
    target_number: '대상 고유번호',
    activity_log: '활동 기록',
    system_boxmark: '(시스템)',
    value_show: '변경 값 열람',
    not_recorded_boxmark: '(기록되지않음)',
    msg_search_activity_list: '검색된 활동 기록이 없습니다.',
    variable: '변수명',
    before_value: '변경 전 값',
    after_value: '변경 후 값',
    settlement_amount: '정산 금액',
    account_number: '계좌번호',
    msg_adjust_warning: '정산 처리는 불가역적입니다. 실행하시겠습니까?',
    msg_adjust_success: '수당 잔액 정산 처리되었습니다.',
    balance_by_asset: '자산별 수당 잔액',
    adjust_success: '정산 처리',
    allowance_adjust_success: '수당 정산 처리',
    msg_account_select: '계좌를 선택해 주세요.',
    msg_account_select_no: '정산 가능 계좌가 존재하지 않습니다.',
    account_list: '계좌 목록',
  },

  relation_list: {
    main_intermediary: '** 본마스터 **',
  },

  outsite_transaction_list: {
    sub_broker: '하위 마스터',
    do_not_select: '선택 안함',
    transaction_history: '마스터 귀속 위부사이트 거래 내역',
    asset_code: '자산 코드',
    asset_name: '자산명',
    transaction: '거래 ID',
    transaction_amount: '거래 금액',
    amount_of_commission: '수수료 금액',
    profit_and_loss: '손익금',
    registration_date: '등록일',
    msg_does_not_exist: '마스터 귀속 외부사이트 거래가 존재하지 않습니다.',
  },

  brokerage_member_list: {
    sub_broker: '하위 마스터',
    not_selecta: '선택 안함',
    msg_not_exist: '마스터 귀속 회원이 존재하지 않습니다.',
  },

  index: {
    broker_information: '마스터 정보',
    control_point: '관리점',
    title: '제목',
    id: '소유자 아이디',
    unique_number: '마스터 고유 번호',
    tax_payer_number: '납세자 번호',
    number: 'SSN, ITIN, 주민등록번호 및 사업자등록번호 등',
    broker_type: '마스터 유형',
    phone_number: '전화 번호',
    registration_date: '등록일',
    address: '주소',
    identification_code: '마스터 식별 코드',
  },

  withdraw_policy: {
    policy_management: '정책 관리',
    inspection_priority: '검사 우선 순위',
    act_of_execution: '실행 행위',
    title: '제목',
    msg_no_registration_policy: '등록 정책이 없습니다.',
    summary: '개요',
    msg_establish_and_discard:
      '출금 승인 업무를 조건에 따라 자동화하는 정책을 수립하고 폐기할 수 있습니다.',
    modification: '정책 수정',
    registration: '정책 등록',
  },

  pg_feeset: {
    msg_fee_bundle: '수수료묶음을 기본 지정하였습니다.',
    fee_bundle_management: '수수료묶음 관리',
    title: '제목',
    fee_rate: '전자산 수수료율',
    basics: '기본',
    msg_no_fee: '등록된 수수료묶음이 없습니다.',
    modification: '수수료묶음 수정',
    registration: '수수료묶음 등록',
  },

  member_view: {
    notification: '알림',
    denial_of_service: '서비스 거부',
    existing_password: '공란일 경우 회원정보 수정 시 기존 비밀번호 승계',
    chief_administrator: '최고 관리자',
    authorization: '권한 부여',
    exclude_statistics: '통계 제외',
    prevention_of_contamination: '정산, 통계 등의 결과에서 제외하여 오염 방지',
    security_rating_value: '보안 등급 값',
    fixation: '고정',
    unrated: '무등급',
    ratinga: '등록',
    assigned_groups: '할당된 그룹',
    group_name: '그룹 이름',
    group_title: '그룹 제목',
    msg_no_group: '등록된 그룹이 없습니다.',
    otp_list: 'OTP 목록',
    registration_date: '등록일',
    msg_no_otp: '등록된 OTP가 없습니다',
    group_registration: '회원 그룹 등록',
    registration: '등록',
    membership_group_registration: '회원 그룹 등록',
  },

  member_list: {
    seq: '회원 고유 번호',
    user_id: '아이디',
    password: '비밀번호',
    email_address: '이메일',
    user_name: '이름',
    is_denied: '정지여부',
    is_admin: '최고관리자 여부',
    regdate: '가입일',
    last_login: '최근 로그인',
    is_alive: '탈퇴 여부',
    deleted_date: '탈퇴일',
    security_level: '보안등급',
    use_statistics_exclude: '통계 제외',
    is_security_level_locked: '보안 등급 값 고정여부',
    inviter_seq: '추천자 회원 고유번호',
    inviter_user_id: '추천자 회원 아이디',
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    member: '회원',
    statistics_exclude_members: '통계 제외 회원 제외',
    chief_administrator: '최고 관리자',
    denial_of_service: '서비스 거부',
  },

  member_invite_relation_list: {
    yourself: '** 본인 **',
    area: '넓이(px)',
    designation: '지정',
  },

  member_group_list: {
    membership_group: '회원 그룹',
    msg_no_membership_group: '등록된 회원 그룹이 없습니다.',
    group_modification: '회원 그룹 수정',
    group_registration: '회원 그룹 등록',
  },

  market: {
    fee_rate: '매도 공시자 수수료율',
    requester_fee_rate: '매수 요청자 수수료율',
    market_name: '시장명',
    market_code: '시장 코드',
    base_assets: '기준 자산',
    quantity_constructor_commission: '수량 조성자 수수료율',
    relative_assets: '상대 자산',
    quantity_user_fee_rate: '수량 이용자 수수료율',
    msg_no_registered: '등록된 B2C 시장이 없습니다.',
    modification: '공개 시장 수정',
    registration: '공개 시장 등록',
  },

  finance_catalog: {
    financial_product_management: '금융 상품 관리',
    name: '이름',
    title: '제목',
    number_of_subscriptions: '가입 횟수',
    total_subscription_amount: '가입 금액 합계',
    msg_no_registration: '등록된 금융 상품이 없습니다.',
    modification: '금융 상품 수정',
    registration: '금융 상품 등록',
  },

  cs_ticket_list: {
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_close: '문의를 종결하시겠습니까?',
    msg_answer_complete: '문의를 답변완료 처리하시겠습니까?',
    above: '등록일(이상)',
    less_than: '등록일(이하)',
    statistics_exclude_members: '통계 제외 회원 제외',
    inquiry_history: 'CS 문의 내역',
    statea: '상태',
    registration_date: '등록일',
    cs_inquiry_id: 'CS문의아이디',
    title: '제목',
    non_member: '(비회원)',
    answer_complete: '답변완료',
    close: '종결',
    contact_request_details: 'CS 문의 요청 상세',
  },

  cs_faq_list: {
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    above: '등록일(이상)',
    less_than: '등록일(이하)',
    registration: '등록',
    cs_faq_history: 'CS FAQ 내역',
    csfaq_number: 'CSFAQ고유번호',
    csfaq_title: 'CSFAQ유형제목',
    title: '제목',
    registration_date: '등록일',
    modify: '수정',
    csfaq_registration: 'CS FAQ 등록',
    csfaq_modify: 'CS FAQ 수정',
  },

  contract_catalog: {
    managing_contract_documents: '계약 문서 관리',
    name: '이름',
    title: '제목',
    document_type: '문서 유형',
    mainly_locale: '주 로캘',
    registration_date: '등록일',
    msg_no_document: '등록된 계약 문서가 없습니다.',
    managing_contract_forms: '계약 양식 관리',
    msg_no_forms: '등록된 계약 양식이 없습니다.',
    modifying_document: '계약 문서 수정',
    register_document: '계약 문서 등록',
    modifying_forms: '계약 양식 수정',
    register_forms: '계약 양식 등록',
  },

  config_service: {
    msg_save: '저장하시겠습니까?',
    check: '확인',
    second: '초',
  },

  config_phone: {
    phone_settings: '전화 설정',
    msg_seting: '발신 시 사용될 정보를 설정합니다.',
    caller_line_number: '발신자 회선 번호',
    telephone_service: '전화 서비스',
    msg_set_the_settings: '발신 여부 및 서비스 제공자에 대한 설정을 합니다.',
    do_not_send: '발신 안함',
    msg_not_actually_emit:
      '제공자를 지정한 것과 동일하게 동작하고 발신 내역에 기록은 되나 실제로 발산하지는 않습니다.',
  },

  config_member: {
    msg_save: '저장하시겠습니까?',
    check: '확인',
    msg_no_exist: '존재하지 않는 그룹 입니다',
    login_identifier: '로그인 식별자',
    all_available_identifiers: '사용 가능한 모든 식별자',
    enable_allow: '추천자 그룹 허용 사용',
    acceptance_group: '추천자 허용 그룹',
  },

  config_cs: {
    type_of_cs_statement: 'CS 문의 유형',
    msg_no_cs_statement: '등록된 CS 문의 유형이 없습니다.',
    cs_faq_type: 'CS FAQ 유형',
    type_name: '유형 이름',
    type_namea: '유형명',
    msg_no_cs_faq: '등록된 CS FAQ 유형이 없습니다.',
    modify: 'CS 문의 유형 수정',
    registration: 'CS 문의 유형 등록',
    faq_modify: 'CS FAQ 유형 수정',
    faq_registration: 'CS FAQ 유형 등록',
  },

  brokerage_catalog_relation_list: {
    main_intermediary: '** 본마스터 **',
  },

  asset_plugin_list: {
    title: '플러그인 제목',
    scan_status: '스캔 여부',
    plug_ins: '자산 플러그인 목록',
  },

  asset_list: {
    asset_code: '자산코드',
    active: '활성 여부',
    deposit: '입금 허용',
    withdrawala: '출금 허용',
    output_order: '출력순서',
    asset_list: '자산 목록',
  },

  affiliate_policy: {
    management: '수당 정책 관리',
    output_ordera: '출력 순서',
    act: '대상 행위',
    whether_or_not: '전역 여부',
    title: '제목',
    msg_no_allowance: '등록된 수당 정책이 없습니다.',
    rectification: '수당 정책 수정',
    registration: '수당 정책 등록',
  },

  acs_catalog: {
    manage_roles: '역할 관리',
    name: '이름',
    title: '제목',
    end_point_method: '종단점 메서드',
    end_point_path: '종단점 경로',
    msg_no_role: '등록된 역할이 없습니다.',
    manage_permissions: '권한 관리',
    modify_role: '역할 수정',
    registering_role: '역할 등록',
    modify_permissions: '권한 수정',
    registration_authority: '권한 등록',
  },

  account_update_balance_bulk: {
    msg_account_number: '계좌 번호가 결번이므로 보류되었습니다.',
    msg_not_exist: '존재하지 않는 입금 전용 주소이므로 보류되었습니다.',
    msg_not_match_depositor: '예금주명이 일치하지 않아 보류되었습니다.',
    choice: '1. 설정 및 파일 선택',
    excel: '엑셀 파일 선택',
    prosecutor: '2. 유효성 검사',
    run_account_validation: '계좌 유효성 검사 실행',
    msg_before_execution:
      '실행 전입니다. 정확한 잔액 대량 직권 정정을 위하여 반드시 실행하셔야 합니다.',
    msg_execution_completed:
      '실행 완료되었습니다. 이제 잔액 대량 직권 정정을 하실 수 있습니다.',
    msg_running:
      '실행 중입니다. 소요 시간은 데이타의 양에 비례합니다. 잠시만 기다려 주세요.',
    balance_correction: '3. 잔액 정정',
    current_status: '현재 상태',
    msg_run_button:
      "실행 전입니다. '실행' 버튼은 클릭하시면 잔액 대량 직권 정정을 시작합니다.",
    msg_download_excel:
      "실행 완료되었습니다. 만일을 대비해 '현재결과 엑셀 다운로드' 버튼을 클릭하여 결과를 저장하시기 바랍니다.",
    msg_wait_a_moment:
      '실행 중입니다. 소요 시간은 데이타의 양에 비례합니다. 페이지 이동은 지양하시고 잠시만 기다려 주세요.',
    adjusted_amount: '조정 금액',
    increase: '증가',
    deductinga: '차감',
    reason: '사유',
    must_matcm: '예금주명이 반드시 일치해야 함',
    practice: '실행',
    number: '번호',
    name: '이름',
    bank_account_number: '계좌번호',
    deposit_only_addresses: '입금전용주소취급',
    amount: '금액',
    account_number_existence: '계좌 번호 존재 여부',
    depositor_name_consistency: '예금주명 일치 여부',
    unique_number: '조회된 계좌 고유 번호',
    account_assets: '계좌 자산',
    checked_depositor: '조회된 예금주명',
    member_unique_number: '조회된 회원 고유 번호',
    state: '상태',
    result_message: '결과 메세지',
    msg_not_exist_excel:
      '엑셀 파일이 선택되지 않았거나 데이타가 존재하지 않습니다.',
  },

  login_me: {
    select_an_intermediary: '마스터 선택',
    shortcuts: '바로가기',
    back: '돌아가기',
  },

  brokerage_console_main: {
    pr_affiliate: '홍보, 제휴 및 중개',
    brokerage_catalog: '마스터 정보',
    sub_broker: '하위 마스터',
    relation_list: '관계도',
    affiliated_member: '귀속 회원',
    external_site_transaction: '외부사이트 거래내역',
    brokerage_balance: '마스터 잔액',
    brokers_equity: '마스터 지분 내역',
    brokerage_settlement: '마스터 정산 내역',
  },

  share_list: {
    seq: '마스터 지분 고유 번호',
    amount: '수당 금액',
    asset_code: '자산 코드',
    asset_seq: '자산 고유 번호',
    asset_title: '자산명',
    base_amount: '원금액',
    base_amount_target: '원금액 대상',
    benefactor_email_address: '시혜자 이메일 주소',
    benefactor_member_seq: '시혜자 회원 고유 번호',
    benefactor_type: '시혜자 유형',
    benefactor_user_id: '시혜자 사용자 아이디',
    benefactor_user_name: '시혜자 사용자명',
    beneficiary_email_address: '수혜자 이메일 주소',
    beneficiary_member_seq: '수혜자 회원 고유 번호',
    beneficiary_type: '수혜자 유형',
    beneficiary_user_id: '수혜자 사용자 아이디',
    beneficiary_user_name: '수혜자 사용자명',
    causer_email_address: '발생자 이메일 주소',
    causer_seq: '발생자 회원 고유 번호',
    causer_user_id: '발생자 사용자 아이디',
    causer_user_name: '발생자 사용자명',
    log_beneficiary_seq: '수당 발생 수혜자 고유 번호',
    log_policy_seq: '수당 발생 적용 정책 고유 번호',
    log_seq: '수당 발생 고유 번호',
    policy_amount: '수당 정책 지정 수당 금액',
    policy_seq: '적용 수당 정책 고유 번호',
    policy_title: '적용 수당 정책명',
    target_action: '대생 행동 유형',
    target_seq: '대상 고유 번호',
    affiliate_log_benefactor_seq: '수당 발생 시혜자 고유 번호',
    brokerage_seq: '마스터 고유 번호',
    brokerage_title: '마스터 제목',
    inherited_amount: '피상속액',
    acquire_rate: '취득율',
    acquire_rate_from_amount: '수당 금액 대비 취득율',
    acquire_amount: '취득액',
    regdate: '등록일',
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    equity_history: '마스터 지분 내역',
    search: '검색',
    sub_broker: '하위 마스터',
    not_select: '선택 안함',
    causer: '발생자',
    behavior_type: '행동 유형',
    occurrence_date: '발생일',
    applied_policy_name: '적용 정책명',
    beneficiary: '시혜자',
    allowance_assets: '수당 자산',
    allowance_amount: '수당 금액',
    number: '번호',
    brokerage_name: '마스터명',
    acquisition_rate: '수당 금액 대비 취득율',
    acquisition_amount: '취득액',
    msg_brokerage_catalog_share_list_no: '검색된 마스터 지분 내역이 없습니다.',
  },

  child_list: {
    modify_sub_brokerage: '하위 마스터 수정',
    sub_broker_registration: '하위 마스터 등록',
    List_sub_brokers: '하위 마스터 목록',
    new_sub: '+ 하위 마스터 신규 등록',
    title: '제목',
    broker_type: '마스터 유형',
    broker_details: '마스터 상세',
    subpoint_registration: '하위점 등록',
    msg_no_sub: '검색된 하위 마스터이 없습니다.',
  },

  child_info: {
    msg_wantto_edit: '수정하시겠습니까?',
    msg_brokerage_register: '마스터을 등록하시겠습니까?',
    msg_brokerage_modify_success: '마스터이 성공적으로 수정되었습니다.',
    msg_brokerage_register_success: '마스터이 성공적으로 등록되었습니다.',
    brokerage_allowed_not: '하위 마스터 등록 불가',
    lowest_broker_type: '최하위 마스터 유형',
    msg_cannot_designate: '을 가진 마스터을 관리점으로 지정할 수 없습니다.',
    control_point: '관리점',
    title: '제목',
    management_poin: '관리점 취득율',
    owner_ID: '소유자 아이디',
    broker_number: '마스터 고유 번호',
    payer_number: '납세자 번호',
    number: 'SN, ITIN, 주민등록번호 및 사업자등록번호 등',
    broker_type: '마스터 유형',
    phone_number: '전화 번호',
    rgistration_date: '등록일',
    not_registered: '(미등록)',
    address: '주소',
    identification_code: '마스터 식별 코드',
    a: '',
  },

  withdraw_transfer_list: {
    seq: '출금 신청 고유 번호',
    account_seq: '계좌 고유 번호',
    member_seq: '회원 고유 번호',
    user_id: '아이디',
    user_name: '이름',
    email_address: '이메일주소',
    account_number: '계좌번호',
    from: '송신 주소',
    to: '수신 주소',
    txid: 'TXID',
    bank_code: '은행',
    asset_title: '자산명',
    asset_code: '자산 코드',
    amount: '전송 금액',
    fee_amount: '전송 수수료',
    status: '상태',
    message: '메세지',
    regdate: '등록일',
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    withdrawal_transmission: '출금 전송 내역',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
    transmit: '송신',
    receive: '수신',
    msg_no_withdrawaa: '검색된 출금 전송 내역이 없습니다.',
  },

  withdraw_policy_info: {
    policy_modified: '정책이 수정되었습니다.',
    policy_registered: '정책이 등록되었습니다.',
    title: '제목',
    type_of_execution: '실행 유형',
    choice: '선택',
    inspection_priority: '검사 우선 순위',
    condition: '조건',
    sequence: '순서',
    must: '아래의 조건을 모두 만족해야 함',
    msg_no_registered: '등록된 조건이 없습니다.',
  },

  withdraw_list: {
    seq: '출금 신청 고유 번호',
    account_seq: '계좌 고유 번호',
    member_seq: '회원 고유 번호',
    withdraw_address_certification_seq: '출금 주소 인증 고유 번호',
    user_id: '아이디',
    user_name: '이름',
    email_address: '이메일주소',
    account_number: '계좌번호',
    holder_name: '예금주명',
    bank_code: '은행',
    fee_type: '수수료 부과 유형',
    fee_amount: '수수료 부과액',
    net_amount: '최종 금액',
    asset_title: '자산명',
    asset_code: '자산 코드',
    request_amount: '신청 금액',
    status: '상태',
    regdate: '등록일',
    withdraw_address: '출금 인증 주소',
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    withdrawal_application_details: '출금신청내역',
    msg_approve: '전체 승인하시겠습니까?',
    msg_reject: '전체 거부하시겠습니까?',
    msg_approved: '전체 승인되었습니다.',
    msg_rejected: '전체 거부되었습니다.',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
    charging_type: '수수료 부과 유형',
    charge_fee: '수수료 부과액',
    final_amount: '최종 금액',
    full_approval: '전체 승인',
    total_deny: '전체 거부',
    selected_withdrawal: '선택한 출금내역',
    cancellation: '취소',
    completion: '완료',
  },

  withdraw_info: {
    msg_re_transfer:
      '(재)전송 시 중복으로 전송될 수 있습니다. 실행하시겠습니까?',
    notification: '알림',
    msg_registered: '전송 요청이 등록되었습니다.',
    msg_key_in: '전송 정보를 Key-In 합니다. 실행하시겠습니까?',
    msg_information: '전송 정보가 등록되었습니다.',
    application_details: '신청 상세',
    re_transfer: '(재)전송',
    key_in: '전송 정보 Key-In',
    amount_transferred: '전송 금액',
    transfer_fee: '전송 수수료',
    send_address: '송신 주소',
    incoming_address: '수신 주소',
    message: '메세지',
    submission: '제출',
    transfer_history: '전송 내역',
  },

  statistic: {
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    category: '항목',
    property: '자산',
    direct: '다이렉트 환전 수수료',
    C2C: 'C2C 수수료',
    deposit_amount: '입금 금액',
    withdrawal_amount: '출금 금액',
    withdrawal_fee: '출금 수수료',
    announces_sale: '매도 공시자',
    purchasing_discloser: '매수 공시자',
    msg_not_date:
      '날짜가 선택되지 않았거나 선택된 날짜 구간 조건과 일치하는 데이타가 없습니다.',
  },

  public_trade_list: {
    seq: ' 시장 체결 고유 번호',
    market_seq: '공개 시장 고유 번호',
    market_title: '공개 시장명',
    market_code: '공개 시장코드',
    is_buyer_maker: '매수자 즉 수량 조성자 여부',
    amount: '체결 수량',
    price: '체결 단가',
    maker_member_seq: '수량 조성자 회원 고유 번호',
    maker_user_id: '수량 조성자 아이디',
    maker_user_name: '수량 조성자 이름',
    maker_email_address: '수량 조성자 이메일 주소',
    maker_account_seq: '수량 조성자 계좌 고유 번호',
    maker_account_number: '수량 조성자 계좌 번호',
    maker_order_seq: '수량 조성자 주문 고유 번호',
    maker_fee_amount: '수량 조성자 수수료',
    taker_member_seq: '수량 이용자 회원 고유 번호',
    taker_user_id: '수량 이용자 아이디',
    taker_user_name: '수량 이용자 이름',
    taker_email_address: '수량 이용자 이메일 주소',
    taker_account_seq: '수량 이용자 계좌 고유 번호',
    taker_account_number: '수량 이용자 계좌 번호',
    taker_order_seq: '수량 이용자 주문 고유 번호',
    taker_fee_amount: '수량 이용자 수수료',
    regdate: '등록일',
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    b2c_engagemen: 'B2C 체결 내역',
    except_creator: '통계 제외 수량 조성자 회원 제외',
    exclude_users: '통계 제외 수량 이용자 회원 제외',
    b2c_movements: 'B2C 자산 이동 내역',
    buying: '매수',
    sell: '매도',
    common: '공통',
    market_buildera: '시장 수량 조성자 정보',
    market_user: '시장 수량 이용자 정보',
    unique_number: '체결 고유 번호',
    id: '아이디',
    account_number: '계좌 번호',
    fee: '수수료',
    quantity_constructor_status: '매수자 즉 수량 조성자 여부',
    name: '이름',
    order_unique_number: '주문 고유 번호',
    msg_no_b2c: '검색된 B2C 주문 내역이 없습니다.',
  },

  public_order_list: {
    seq: '공개 시장 주문 고유 번호',
    market_seq: '공개 시장 고유 번호',
    market_title: '공개 시장명',
    market_code: '공개 시장코드',
    account_seq: '계좌 고유 번호',
    account_number: '계좌 번호',
    user_id: '아이디',
    user_name: '이름',
    call_price: '호가',
    call_amount: '호가 수량',
    executable_amount: '체결 가능 수량',
    filled_amount: '체결 수량',
    commulative_target_amount: '누적 상대 자산 수량',
    is_executable: '체결 가능 여부',
    side_type: '거래 방향',
    status: '상태',
    closed_date: '종결일',
    regdate: '등록일',
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    b2c_list: 'B2C 주문내역',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
    b2c_movements: 'B2C 자산 이동 내역',
    unique_number: '주문 고유 번호',
    bank_account_number: '계좌번호',
    asking_price: '호가',
    fastened: '체결 가능 수량',
    relative: '누적 상대 자산 수량',
    transaction_direction: '거래 방향',
    the_asking_price: '호가 수량',
    tightening_quantity: '체결 수량',
    can_be_fastened: '체결 가능 여부',
    state: '상태',
    closing_date: '종결일',
    unterminated: '미종결',
    msg_no_b2c: '검색된 B2C 주문 내역이 없습니다.',
  },

  public_market_info: {
    msg_modify: '수정되었습니다.',
    msg_registered: '등록되었습니다.',
    market_seq: '공개 시장 고유 번호',
    market_name: '시장명',
    code: '코드',
    allow_deposit: '예치 허용',
    allow_withdrawals: '인출 허용',
    output_order: '출력 순서',
    minimum_asking: '최소 호가 수량',
    use: '사용',
    base_assets: '기준 자산',
    relative_assets: '상대 자산',
    creator: '수량 조성자 수수료율',
    user: '수량 이용자 수수료율',
  },

  public_balance_transfer_list: {
    seq: '공개 시장 잔액 이동 고유 번호호',
    market_seq: '공개 시장 고유 번호',
    market_title: '공개 시장명',
    market_code: '공개 시장코드',
    user_id: '아이디',
    user_name: '이름',
    email_address: '이메일주소',
    account_number: '계좌번호',
    account_seq: '계좌 고유 번호',
    balance_seq: '공개 시장 잔액 고유 번호',
    transfer_type: '이동 유형',
    amount: '이동 수량',
    regdate: '등록일',
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    B2C: 'B2C 자산 이동 내역',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
    movements: 'B2C 자산 이동 내역',
    bank_account_number: '계좌번호',
    msg_no_b2c: '검색된 B2C자산 이동내역이 없습니다.',
  },

  private_market_info: {
    direct_exchange_market: '다이렉트 환전 시장 추종',
    do_not_follow: '추종하지 않음',
    follow: '추종',
    choice: '선택',
    designated: '시장을 추종 대상으로 지정함',
    minimum_spread: '최소 스프레드 비율',
    maximum_spread: '최대 스프레드 비율',
    announces: '매도 공시자',
    solicitor: '매수 요청자',
    safety_type: '구매 안전 유형',
    msg_immediately:
      '매도 공시자와 매수 요청자의 거래가 즉시 이루어지도록 합니다. 거래 속도가 가장 빠릅니다.',
    msg_disclosure:
      "매도 공시자가 사측에 매도할 자산을 우선 예치하고 매도 공시 등록 시 대상 자산의 지불 방법을 지정합니다. 매수 요청자는 매도 공시자가 지정한 대상 자산 지불 방법에 따라 매도 공시자에게 대상 자산을 지불합니다. 매수 요청자가 '지불 완료' 처리하면 거래 상태 해소 전까지 매도 공시자의 계좌에 지급 정지가 설정됩니다.",
    msg_requester:
      "매수 요청자가 사측에 매수할 자산을 우선 예치하고 매수 요청 등록 시 원자산의 지불 방법을 지정합니다. 매도 공시자는 매수 요청자가 지정한 원자산 지불 방법에 따라 매수 요청자에게 원자산을 지불합니다. 매도 공시자가 '지불 완료' 처리하면 거래 상태 해소 전까지 매수 요청자의 계좌에 지급 정지가 설정됩니다.",
    msg_both_sides:
      ' 매도 공시자와 매수 요청자 양측 모두 예치하지 않습니다. 거래자 상호 신뢰가 있다고 판단될 때에만 사용하여야 합니다.',
    form: '매수 요청자 추가 작성 양식',
  },

  private_deal_list: {
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
  },

  private_application_list: {
    seq: '매수 요청 고유 번호',
    market_seq: 'c2c 마켓 고유 번호',
    market_title: 'c2c 마켓명',
    user_id: '아이디',
    user_name: '이름',
    email_address: '이메일주소',
    source_asset_title: '원자산 명',
    source_asset_code: '원자산 코드',
    target_asset_title: '대상자산 명',
    target_asset_code: '대상자산 코드',
    deal_seq: 'c2c 매도 공시 고유 번호',
    deal_member_seq: 'c2c 매도 공시 회원 고유 번호',
    deal_fee_amount: 'c2c 매도 공시자 수수료액',
    deal_account_number: 'c2c 매도 계좌',
    account_number: 'c2c 매수 계좌',
    account_seq: 'c2c 매수 계좌 고유 번호',
    source_amount: '원자산 수량',
    fee_amount: 'c2c 매수 요청자 수수료액',
    price: '수량당 가격',
    status: '상태',
    regdate: '등록일',
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_change: '정말로 상태를 변경하시겠습니까?',
    msg_complete: '상태 변경이 완료되었습니다.',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    c2c_purchase: 'C2C 매수 요청 내역',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
    sales_discloser_fee: '매도 공시자 수수료액',
    price_per_quantity: '수량당 가격',
    purchase_requeste: '매수 요청자 수수료액',
    cancellation: '취소',
    Payment: '지불',
    companion: '반려',
    confirmation: '확정',
  },

  pg_transaction_list: {
    seq: '거래 고유 번호',
    asset_seq: '자산 고유 번호',
    user_id: '아이디',
    user_name: '이름',
    merchant_id: '상점 아이디',
    merchant_name: '상점명',
    order_id: '상점 주문 번호',
    transaction_id: '거래 아이디',
    feeset_title: '적용 수수료묶음',
    fee_rate: '적용 수수료율',
    fee_amount: '부과 수수료액',
    amount: '거래 금액',
    net_amount: '최종 정산 금액',
    refundable_amount: '환불 가능 금액',
    payer_name: '결제자명',
    transaction_type: '거래 유형',
    status: '상태',
    regdate: '등록일',
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    pg_transaction: 'PG 거래 내역',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
    application_fee: '적용 수수료묶음',
    transaction_name: '거래 명칭',
    not_applied: '수수료묶음 미적용',
    no_pg: '검색된 PG 거래 내역이 없습니다.',
  },

  pg_merchant_nav: {
    list: '목록으로',
    information: '상점정보',
  },

  pg_merchant_list: {
    seq: '상점 고유 번호',
    member_seq: '회원 고유 번호',
    user_id: '아이디',
    user_name: '이름',
    email_address: '이메일 주소',
    merchant_id: '상점 아이디',
    merchant_name: '상점 이름',
    api_signature: '상점 서명키',
    status: '상태',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    list_of_stores: '상점 목록',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
    store_name: '상점명',
    registration_date: '등록일',
    store_details: '상점 상세',
  },

  pg_merchant_info: {
    store_id: '상점 아이디',
    store_unique_number: '상점 고유 번호',
    store_name: '상점명',
    application_fee: '적용 수수료묶음',
    follow_defaul: '기본 지정된 수수료묶음을 따름',
    no_default: '[기본 지정 수수료묶음 없음]',
    store_signature_key: '상점 서명키',
    automatic_generation: '(자동 생성)',
  },

  pg_feeset_info: {
    title: '제목',
    electronic_property_fee: '전자산 수수료율',
    fee_by_asset: '자산별 수수료',
    settlement_assets: '결제 자산',
    commission_rate: '수수료율',
    msg_no_registered: '등록된 수수료가 없습니다',
    choice: '선택',
  },

  oauth2_client_list: {
    client_information: '클라이언트 정보',
    client_new: '클라이언트 신규',
    id: '클라이언트 ID',
    oauth2_client: 'Oauth2 클라이언트',
    new: '신규 생성',
    name: '클라이언트명',
    secret: '클라이언트 Secret',
    registration_date: '등록일',
    msg_no_clints: '등록된 클라인트가 없습니다.',
  },

  oauth2_client_info: {
    msg_modified: '클라이언트 수정되었습니다.',
    msg_registered: '클라이언트 등록되었습니다.',
    name: '클라이언트명',
    id: '클라이언트 ID',
    automatic_generation: '(자동 생성)',
    secret: '클라이언트 Secret',
    url: '리디렉트 URI',
    right: '권한',
    choice: '선택',
    msg_not_egistered: '등록된 클라이언트 권한이 없습니다.',
  },

  member_nav: {
    retained: '보유 OAuth2 Client',
    recommended_relationship: '추천 관계도',
  },

  member_group_info: {
    msg_modified: '회원 그룹이 수정되었습니다',
    msg_registered: '회원 그룹이 등록되었습니다',
    member_group: '회원 그룹명',
    member_group_name: '회원 그룹 이름',
    member_output_order: '회원 출력 순서',
  },

  member_by_group_info: {
    msg_membership_group: '회원 그룹이 등록되었습니다',
    select_group: '그룹 목록',
    msg_select_group: '그룹을 선택해주세요',
  },

  member_affiliate_policy: {
    msg_completed_successfully: '수당 정책 적용이 성공적으로 완료되었습니다.',
    msg_successfully_removed:
      '회원 적용 수당 정책이 성공적으로 말소되었습니다.',
    membership_allowance_policy: '회원 적용 수당 정책',
    msg_select: '할당할 수당 정책을 선택해 주세요.',
    msg_not_exist: '할당 가능한 수당 정책이 존재하지 않습니다.',
    application: '적용',
    act_of_subject: '대상 행위',
    policy_title: '정책 제목',
    msg_no_allowance: '적용된 수당 정책이 없습니다.',
  },

  member_acs_grant: {
    member_applied_acs: '회원 적용 ACS 권한',
    msg_select_acs: '할당할 ACS 권한을 선택해 주세요.',
    msg_not_exist: '할당 가능한 ACS 권한이 존재하지 않습니다.',
    application: '적용',
    privilege_name: '권한 이름',
    permission_title: '권한 제목',
    msg_not_have: '적용된 ACS 권한이 없습니다.',
  },

  loginlog_list: {
    search: '검색',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
    msg_successfully: 'ACS 권한 적용이 성공적으로 완료되었습니다.',
    msg_revoked: '회원 적용 ACS 권한이 성공적으로 말소되었습니다.',
  },

  lang_search_item: {
    elimination: '삭제',
  },

  kyc_realname_list: {
    kyc_realname_list: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    seq: '실명 인증 고유 번호',
    member_seq: '회원 고유 번호',
    user_id: '아이디',
    user_name: '이름',
    authority: '인증기관',
    name: '실명 인증 이름',
    sex: '성별',
    nationality: '국적',
    birth_date: '생일',
    di: '중복가입 확인값',
    ci: '연계정보 확인값',
    cell_carrier: '통신사',
    cell_number: '전화번호',
    status: '상태',
    is_valid: '유효 여부',
    closed_date: '종결일',
    expdate: '만료일',
    ipaddress: 'IP 주소',
    regdate: '등록일',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    real_name: '실명인증 내역',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
  },

  kyc_certification_info: {
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
  },

  kyc_asset_withdraw_address_certification_list: {
    _no: '번호',
    seq: 'KYC 자산 출금 주소 인증 고유 번호',
    asset_seq: '자산 고유 번호',
    asset_code: '자산 코드',
    asset_title: '자산 이름',
    bank_code: '은행 코드',
    withdraw_address: '출금 주소',
    holder_name: '소유자명',
    member_seq: '회원 고유 번호',
    user_id: '아이디',
    user_name: '이름',
    email_address: '이메일 주소',
    status: '상태',
    is_valid: '유효 여부',
    regdate: '등록일',
    expdate: '만료일',
    closed_date: '종결일',
    ipaddress: 'IP 주소',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    KYC_authentication: 'KYC출금 주소(계좌) 인증',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
  },

  finance_return_list: {
    seq: '수당 잔액 고유 번호',
    member_unique_number: '회원 고유 번호',
    id: '아이디',
    name: '이름',
    email: '이메일 주소',
    balance: '잔액',
    cumulative_amount: '누적 금액',
    first_payment_date: '최초 지급일',
    asset_name: '자산명',
    asset_code: '자산 코드',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    financial_return_history: '금융 반환 내역',
    return_account_number: '반환 계좌 번호',
    fund_account_number: '자금 계좌 번호',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
    financial_instruments_name: '금융 상품명',
    return_type: '반환 유형',
    amount: '원금액',
    principal_amount: '원리금액',
    registration_date: '등록일',
    type_of_financial: '금융 상품 유형',
    patient_type: '반환자 유형',
    amount_of_money: '이자액',
    msg_no_financial: '검색된 금융 반환이 없습니다.',
  },

  finance_nav: {
    setting: '설정',
    breakdown_of_funds: '자금 내역',
    return_history: '반환 내역',
    dividend_details: '배당 내역',
  },

  finance_instrument_info: {
    title: '제목',
    description_summary: '설명 요약',
    type_of_financial: '금융 상품 유형',
    select_product_type: '(상품 유형 선택)',
    application: '적용 계약 양식',
    select: '(계약 양식 선택)',
    name: '이름',
    executable_asset: '실행 자산',
    select_asset: '자산 선택',
    subscription_start_date: '가입 시작일',
    use: '사용',
    msg_select_start_date: '시작일을 선택해 주세요',
    disable_subscription_start: '가입 시작일 사용 안함',
    end_date: '가입 종료일',
    msg_select_end_date: '종료일을 선택해 주세요',
    disable_subscription_end: '가입 종료일 사용 안함',
    date_of_execution: '실행 시작일',
    execute_end: '실행 종료일',
    settlement_date: '정산일 시작일',
    execution_amount_bundle: '실행 금액 묶음',
    join_and_run: '{0} 단위로 가입 후 실행',
    msg_execution_asset: '실행 자산을 선택해 주세요',
    minimum_amount: '최소 실행 금액',
    disable_minimum: '최소 실행 금액 사용 사용 안함',
    maximum_amount: '최대 실행 금액',
    disable_maximum: '최대 실행 금액 사용 사용 안함',
    profit_for_dividends: '금융 상품 배당용이익',
    dividend_profit_assets: '배당용이익 자산',
    dividend_income: '배당이익금',
    choice: '선택',
    msg_no_benefit: '등록된 금융 상품 배당용이익이 없습니다.',
  },

  finance_fund_list: {
    balance_unique_number: '수당 잔액 고유 번호',
    member_unique_number: '회원 고유 번호',
    id: '아이디',
    name: '이름',
    email_address: '이메일 주소',
    balance: '잔액',
    accumulated_amount: '누적 금액',
    first_payment_date: '최초 지급일',
    asset_title: '자산명',
    asset_code: '자산 코드',
    msg_server_overload:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    financial_details: '금융 자금 내역',
    fund_account_number: '자금 계좌 번호',
    execution_account_number: '실행 계좌 번호',
    statistics_exclude_members: '통계 제외 회원 제외',
    members_excluded: '탈퇴 회원 제외',
    financial_product: '금융 상품명',
    account_number: '자금 계좌 번호',
    date_of_execution: '실행 시작일',
    execution_amount: '실행 금액',
    cancellation_status: '해지 여부',
    settlement_start: '정산 시작일',
    financial_instrument: '금융 상품 유형',
    execution: '실행 계좌 번호',
    expiry_date: '만기일',
    completed_or_not: '반환 완료 여부',
    revocation_type: '해지 유형',
    registration_date: '등록일',
    msg_no_financial: '검색된 금융 자금이 없습니다.',
  },
  direct_transfer_list: {
    exchange_unique_number: '환전 고유 번호',
    member_unique_number: '회원 고유 번호',
    rotation_type: '환전 유형',
    sales_base_rate: '적용 매매기준율',
    id: '아이디',
    name: '이름',
    base_assets: '기준 자산',
    base_assets_account: '기준 자산 계좌',
    applied_exchange_rate: '적용 환율',
    base_assets_quantity: '기준 자산 수량',
    relative_assets: '상대 자산',
    relative_asset_account: '상대 자산 계좌',
    relative_asset_quantity: '상대 자산 수량',
    applied_spread_rate: '적용 스프레드율',
    registration_date: '등록일',

    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_when_downloading_excel:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    exchange_details: '환전내역',
    statistics_exclude_members: '통계 제외 회원 제외',
    withdrawal_members_excluded: '탈퇴 회원 제외',
  },
  deposit_list: {
    seq: '입금 신청 고유 번호',
    account_seq: '계좌 고유 번호',
    member_seq: '회원 고유 번호',
    user_id: '아이디',
    user_name: '이름',
    email_address: '이메일주소',
    account_number: '계좌번호',
    asset_title: '자산명',
    asset_code: '자산 코드',
    request_amount: '신청 금액',
    status: '상태',
    regdate: '등록일',
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_excel_warning:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    msg_approve: '전체 승인하시겠습니까?',
    msg_reject: '전체 거부하시겠습니까?',
    msg_approved: '전체 승인되었습니다.',
    msg_rejected: '전체 거부되었습니다.',
    use_statistics_exclude: '통계 제외 회원 제외',
    member_is_alive: '탈퇴 회원 제외',
    approve: '전체 승인',
    reject: '전체 거부',
    deposit_request: '입금신청내역{0}',
    selecte_deposit_history: '선택한 입금내역',
    application_amount: '신청 금액',
    cancel: '취소',
    done: '완료',
  },
  contract_form_info: {
    name: '이름',
    title: '제목',
    contract_document: '계약 문서',
    required_consent: '필수 동의 여부',
    select: '선택',
    required: '필수',
    is_agree_required: '필수 동의',
    msg_contract_document_no: '등록된 계약 양식 문서가 없습니다.',
  },
  cs_ticket_type_info: {
    msg_cs_type_modify: 'CS 문의 유형이 수정되었습니다',
    msg_cs_type_register: 'CS 문의 유형이 등록되었습니다',
    title: 'CS 문의 유형명',
    name: 'CS 문의 유형 이름',
    list_order: 'CS 문의 출력 순서',
    use_content: 'CS 문의 내용 사용',
    allow_guest: 'CS 문의 비회원 허용',
    use_notify: 'CS 문의 고객 사건알림 허용',
    use_notify_manager: 'CS 문의 관리자 사건알림 허용',
  },
  cs_ticket_info: {
    msg_inquiry_answer: '문의에 답변하시겠습니까?',
    msg_inquiry_answer_success: '문의 답변에 성공했습니다',
    msg_inquiry_ending: '문의를 종결하시겠습니까?',
    msg_inquiry_answer_ending: '문의를 답변완료 처리하시겠습니까?',
    non_member: '비회원',
    title: '제목',
    content: '내용',
    nodone: '(없음)',
    answer: '답변',
    answer_register: '답변등록',
    answer_success: '답변완료',
    ending: '종결',
  },
  cs_faq: {
    modify: '수정',
    register: '등록',
    msg_cs_modify: 'CS FAQ가 수정되었습니다',
    msg_cs_register: 'CS FAQ가 등록되었습니다',
    cs_info: 'CS FAQ 정보',
    cs_type: 'CS FAQ 유형',
    type_selete: '유형 선택',
    title: '제목',
    content: '내용',
  },
  cs_faq_type_info: {
    msg_cs_modify: 'CS FAQ 유형이 수정되었습니다',
    msg_cs_register: 'CS FAQ 유형이 등록되었습니다',
    cs_type: 'CS FAQ 유형명',
    cs_type_name: 'CS FAQ 유형 이름',
  },
  contract_nav: {
    contract_catalog: '설정',
    contract_agreement_list: '약정 내역',
  },
  contract_document_info: {
    document_type: '문서 유형',
    main_locale: '주 로캘',
    name: '이름',
    title: '제목',
    info: '설명',
    contract_language: '계약 언어',
    master_locale: '주 로캘인',
    msg_master_locale:
      "에 대한 계약 문서 언어가 등록되어 있지 않습니다. '추가' 버튼을 클릭하여 등록을 완료해 주세요. 등록하지 않을 경우 추후 고객과의 법적 분쟁이 발생할 수 있음을 알려드립니다.",
    locale: '로캘',
    content_write: '내용 작성/첨부',
    select: '선택',
    msg_contract_document_register_no: '등록된 계약 문서 언어가 없습니다.',
  },
  brokerage_share_list: {
    seq: '마스터 지분 고유 번호',
    amount: '수당 금액',
    asset_code: '자산 코드',
    asset_seq: '자산 고유 번호',
    asset_title: '자산명',
    base_amount: '원금액',
    base_amount_target: '원금액 대상',
    benefactor_email_address: '시혜자 이메일 주소',
    benefactor_member_seq: '시혜자 회원 고유 번호',
    benefactor_type: '시혜자 유형',
    benefactor_user_id: '시혜자 사용자 아이디',
    benefactor_user_name: '시혜자 사용자명',
    beneficiary_email_address: '수혜자 이메일 주소',
    beneficiary_member_seq: '수혜자 회원 고유 번호',
    beneficiary_type: '수혜자 유형',
    beneficiary_user_id: '수혜자 사용자 아이디',
    beneficiary_user_name: '수혜자 사용자명',
    causer_email_address: '발생자 이메일 주소',
    causer_seq: '발생자 회원 고유 번호',
    causer_user_id: '발생자 사용자 아이디',
    causer_user_name: '발생자 사용자명',
    log_beneficiary_seq: '수당 발생 수혜자 고유 번호',
    log_policy_seq: '수당 발생 적용 정책 고유 번호',
    log_seq: '수당 발생 고유 번호',
    policy_amount: '수당 정책 지정 수당 금액',
    policy_seq: '적용 수당 정책 고유 번호',
    policy_title: '적용 수당 정책명',
    target_action_type: '대상 행동 유형',
    target_seq: '대상 고유 번호',
    affiliate_log_benefactor_seq: '수당 발생 시혜자 고유 번호',
    brokerage_seq: '마스터 고유 번호',
    brokerage_title: '마스터 제목',
    inherited_amount: '피상속액',
    acquire_rate: '취득율',
    acquire_amount: '취득액',
    regdate: '등록일',
    shortcuts_today: '금일',
    shortcuts_yesterday: '작일',
    shortcuts_thismonth: '금월',
    shortcuts_lastmonth: '작월',
    shortcuts_thisweek: '금주',
    shortcuts_lastweek: '작주',
    shortcuts_week: '최근 7일',
    shortcuts_month: '최근 30일',
    msg_excel_warning:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    brokerage_catalog_share_list: '마스터 지분 내역{0}',
    search: '검색',
    use_statistics_exclude: '통계 제외 회원 제외',
    member_is_alive: '탈퇴 회원 제외',
    target_action: '대상 행동',
    all: '전체',
    target_action_seq: '대상 행동 고유번호',
    causer: '발생자',
    behavior_type: '행동 유형',
    occurrence_date: '발생일',
    applied_policy_name: '적용 정책명',
    benefactor: '시혜자',
    allowance_assets: '수당 자산',
    allowance_amount: '수당 금액',
    number: '번호',
    brokerage_name: '마스터명',
    msg_brokerage_catalog_share_list_no: '검색된 마스터 지분 내역이 없습니다.',
  },
  brokerage_nav: {
    brokerage_list: '마스터 목록',
    brokerage_catalog: '마스터 정보',
    brokerage_catalog_relation_list: '관계도',
    brokerage_catalog_balance_list: '자산별 잔액',
    brokerage_catalog_share_list: '지분 내역',
    brokerage_catalog_adjust_list: '정산 내역',
  },
  brokerage_list: {
    seq: '마스터 고유 번호',
    member_seq: '회원 고유 번호',
    user_id: '아이디',
    user_name: '이름',
    email_address: '이메일 주소',
    title: '제목',
    identification_code: '식별 코드',
    brokerage_type: '마스터 유형',
    regdate: '등록일',
    msg_excel_warning:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    brokerage_list: '마스터 목록{0}',
    brokerage_modify: '마스터 수정',
    brokerage_register: '마스터 등록',
    use_statistics_exclude: '통계 제외 회원 제외',
    member_is_alive: '탈퇴 회원 제외',
    brokerage_register_new: '+ 최상위 마스터 신규 등록',
    brokerage_detail: '마스터 상세',
    subpoint_registration: '하위점 등록',
    msg_search_brokerage_no: '검색된 마스터이 없습니다.',
  },
  brokerage_info: {
    msg_wantto_edit: '수정하시겠습니까?',
    msg_brokerage_register: '마스터을 등록하시겠습니까?',
    msg_brokerage_modify_success: '마스터이 성공적으로 수정되었습니다.',
    msg_brokerage_register_success: '마스터이 성공적으로 등록되었습니다.',
    brokerage_allowed_not: '하위 마스터 등록 불가',
    lowest_broker_type: '최하위 마스터 유형',
    msg_cannot_be_designated: '을 가진 마스터을 관리점으로 지정할 수 없습니다.',
    management: '관리점',
    title: '제목',
    management_acquisition: '관리점 취득율',
    target_id: '소유자 아이디',
    brokerage_number: '마스터 고유 번호',
    taxpayer_number: '납세자 번호',
    number: 'SSN, ITIN, 주민등록번호 및 사업자등록번호 등',
    brokerage_type: '마스터 유형',
    phone_number: '전화 번호',
    regdate: '등록일',
    unregistered: '(미등록)',
    address: '주소',
    brokerage_code: '마스터 식별 코드',
  },
  brokerage_balance_list: {
    seq: '지분 잔액 고유 번호',
    brokerage_title: '마스터 제목',
    amount: '잔액',
    total_amount: '누적 금액',
    asset_title: '자산명',
    asset_code: '자산 코드',
    msg_excel_warning:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    equity_balances_list: '지분 잔액 목록',
    msg_adjust_warning: '정산 처리는 불가역적입니다. 실행하시겠습니까?',
    msg_balance_settlement_success: '지분 잔액 정산 처리되었습니다.',
    equity_balance_asset: '자산별 지분 잔액',
    adjust_success: '정산 처리',
    msg_brokerag_balance_no: '검색된 마스터 지분 잔액이 없습니다.',
    equity_settlement_processing: '지분 정산 처리',
    msg_account_select: '계좌를 선택해 주세요.',
    msg_account_select_no: '정산 가능 계좌가 존재하지 않습니다.',
    execution: '실행',
    brokerage_balance_list:
      '{0}마스터의 {1} 지분 {2} 전액을 아래 계좌로 정산 처리',
  },
  brokerage_adjust_list: {
    seq: '지분 잔액 고유 번호',
    member_seq: '회원 고유 번호',
    user_id: '아이디',
    user_name: '이름',
    email_address: '이메일 주소',
    amount: '잔액',
    total_amount: '누적 금액',
    regdate: '최초 지급일',
    asset_title: '자산명',
    asset_code: '자산 코드',
    msg_excel_warning:
      '엑셀 다운로드 시 데이타의 양이 방대한 경우 서버 과부하 및 브라우저 작동 중지 현상이 발생할 수 있습니다. 실행하시겠습니까?',
    use_statistics_exclude: '통계 제외 회원 제외',
    member_is_alive: '탈퇴 회원 제외',
    share_settlement_list: '지분 정산 내역',
    title: '마스터 제목',
    settlement_amount: '정산 금액',
    account_number: '계좌번호',
    regday: '등록일',
    msg_search_settlement_history_no: '검색된 마스터 정산 내역이 없습니다.',
    share_settlement_history: '지분 정산 내역{0}',
  },
  asset_withdraw_fee: {
    order: '순서',
    commission: '수수료',
    withdrawal_commission_same: '출금 계좌와 수수료 납부 계좌 동일',
    fee_payment_account_can: '수수료 납부 계좌 별도 지정 가능',
    msg_asset_withdrawal_fee_no: '등록된 자산 출금 수수료가 없습니다.',
  },
  asset_info: {
    withdrawal_fee_usage: '출금 수수료 사용',
    msg_withdrawal_fee_done: "'출금 수수료' 탭에서 상세 설정을 완료해 주세요.",
    withdrawal_fee: '출금 수수료',
  },
  affiliate_policy_info: {
    msg_allowance_policy_modify: '수당 정책이 수정되었습니다.',
    msg_allowance_policy_register: '수당 정책이 등록되었습니다.',
    title: '제목',
    global_coverage: '전역 전용',
    apply_no: '적용안함',
    apply_ok: '적용함',
    target_action: '대상 행동',
    select: '선택',
    output_order: '출력 순서',
    causer_condition: '발생자 조건',
    action_condition: '대상 행동 조건',
    beneficiary: '수혜자',
  },
  affiliate_policy_causer_condition: {
    order: '순서',
    condition_satisfied: '아래의 조건을 모두 만족해야 함',
    msg_register_occurrence_target_no: '등록된 발생자 조건이 없습니다.',
  },
  affiliate_policy_beneficiary: {
    allowance_policy_beneficiary: '수당 정책 수혜자',
    output_order: '출력 순서',
    beneficiary_type: '수혜자 유형',
    beneficiary: '수혜자',
    member_unique_number: '회원 고유 번호가',
    relationship_with_originator: '발생자와의 추천 관계 깊이가',
    msg_allowance_policy_no: '등록된 수당 정책 수혜자가 없습니다.',
    allowance_policy_modify: '수당 정책 수혜자 수정',
    allowance_policy_register: '수당 정책 수혜자 등록',
  },
  affiliate_policy_beneficiary_info: {
    msg_allowance_policy_modify: '수당 정책 수혜자가 수정되었습니다.',
    msg_allowance_policy_register: '수당 정책 수혜자가 등록되었습니다.',
    beneficiary_type: '수혜자 유형',
    member_unique_number: '회원 고유 번호',
    referral_depth: '추천 관계 깊이',
    output_order: '출력 순서',
    condition: '조건',
    benefit: '시혜자',
  },
  affiliate_policy_beneficiary_condition: {
    order: '순서',
    condition_satisfied: '아래의 조건을 모두 만족해야 함',
    // this: '이',
    // must_be: '이어야 함',
    msg_allowance_policy_no: '등록된 수당 정책 수혜자 조건이 없습니다.',
  },
  affiliate_policy_benefactor: {
    order: '순서',
    benefit: '시혜자',
    benefit_type: '시혜자 유형',
    msg_allowance_policy_no: '등록된 수당 정책 수혜자별 시혜자가 없습니다.',
  },
  affiliate_policy_action_condition: {
    order: '순서',
    condition_satisfied: '아래의 조건을 모두 만족해야 함',
    // this: '이',
    // must_be: '이어야 함',
    msg_behavior_conditions: '등록된 행동 조건이 없습니다.',
  },
  affiliate_log_list: {
    search: '검색',
    use_statistics_exclude: '통계 제외 회원 제외',
    member_is_alive: '탈퇴 회원 제외',
    target_action: '대상 행동',
    all: '전체',
    target_seq: '대상 행동 고유번호',
    payment_history: '수당 발생 내역',
    easy_info: '쉬운 설명으로 보기',
    occurrence_target: '발생자',
    behavior_type: '행동 유형',
    target_unique_number: '대상 고유 번호',
    occurrence_date: '발생일',
    applied_policy_name: '적용 정책명',
    beneficiary_type: '수혜자 유형',
    beneficiary: '수혜자',
    number: '번호',
    benefit_type: '시혜자 유형',
    principal_amount_target: '원금액 대상',
    allowance_assets: '수당 자산',
    benefit: '시혜자',
    principal_amount: '원금액',
    allowance_amount: '수당 금액',
    msg_allowance_amount_no: '검색된 수당 발생 내역이 없습니다.',
    occurrence_info: '발생 정보',
    policy_info: '정책 정보',
    beneficiary_info: '수혜자 정보',
    benefit_info: '시혜 정보',
  },
  affiliate_balance_list: {
    seq: '수당 잔액 고유 번호',
    member_seq: '회원 고유 번호',
    user_id: '아이디',
    user_name: '이름',
    email_address: '이메일 주소',
    amount: '잔액',
    total_amount: '누적 금액',
    asset_title: '자산명',
    asset_code: '자산 코드',

    allowance_balances_list: '수당 잔액 목록 {0}',
    msg_adjust_to_account: '{0}님의 {1} 수당 {2} 전액을 아래 계좌로 정산 처리',
  },
  affiliate_adjust_list: {
    seq: '수당 잔액 고유 번호',
    member_seq: '회원 고유 번호',
    user_id: '아이디',
    user_name: '이름',
    email_address: '이메일 주소',
    amount: '잔액',
    total_amount: '누적 금액',
    regdate: '최초 지급일',
    asset_title: '자산명',
    asset_code: '자산 코드',

    allowance_settlement_list: '수당 정산 내역{0}',
  },
  activity_log_list: {
    seq: '로그 고유번호',
    eventer_seq: '실행자 고유 번호',
    description: '로그 설명',
    ipaddress: 'IP 주소',
    user_agent: '단말정보',
    default_locale: '기본 로캘',
    regdate: '등록일',
    logset_seq: '로그 묶음 고유 번호',
    target: '대상',
    target_seq: '대상 고유 번호',
    reference: '참조',
    reference_seq: '참조 고유 번호',
    logset_description: '로그 묶음 설명',
    user_id: '사용자 아이디',
    email_address: '이메일 주소',
    user_name: '이름',
    logset_description_replaced: '로그 묶음 설명 치환 값',
    description_replaced: '로그 설명 치환 값',

    activity_history: '활동내역{0}',
  },
  account_transfer_list: {
    seq: '이체 신청 고유 번호',
    asset_seq: '자산 고유 번호',
    from_seq: '출금 계좌 고유 번호',
    to_seq: '입금 계좌 고유 번호',
    amount: '이체 금액',
    from_member_seq: '출금 계좌 회원 고유 번호',
    to_member_seq: '입금 계좌 회원 고유 번호',
    from_account_number: '출금 계좌 번호',
    to_account_number: '입금 계좌 번호',
    from_user_name: '출금 계좌 회원 이름',
    to_user_name: '입금 계좌 회원 이름',
    asset_title: '자산명',
    asset_code: '자산 코드',
    regdate: '등록일',
    from_user_id: '출금 계좌 회원 아이디',
    from_email_address: '출금 계좌 회원 이메일',
    to_user_id: '입금 계좌 회원 아이디',
    to_email_address: '입금 계좌 회원 이메일',

    transfer_request_list: '이체신청내역{0}',
  },
  account_list: {
    seq: '계좌 고유 번호',
    member_seq: '회원 고유 번호',
    address_seq: '입금 전용 주소 고유 번호',
    user_id: '아이디',
    user_name: '이름',
    email_address: '이메일 주소',
    title: '계좌 이름',
    account_number: '계좌번호',
    balance: '잔액',
    status: '상태',
    regdate: '개설일',
    address: '입금 전용 주소',
    asset_title: '자산명',
    asset_code: '자산 코드',
    holding_balance: '정지금액',

    account_history: '계좌 목록{0}',
  },
  account_balance_log_list: {
    seq: '로그 고유번호',
    eventer_seq: '실행자 고유 번호',
    description: '로그 설명',
    ipaddress: 'IP 주소',
    user_agent: '단말정보',
    default_locale: '기본 로캘',
    regdate: '등록일',
    logset_seq: '로그 묶음 고유 번호',
    target: '대상',
    target_seq: '대상 고유 번호',
    reference: '참조',
    reference_seq: '참조 고유 번호',
    logset_description: '로그 묶음 설명',
    user_id: '사용자 아이디',
    email_address: '이메일 주소',
    user_name: '이름',
    before: '이전 값',
    after: '이후 값',
    logset_description_replaced: '로그 묶음 설명 치환 값',
    description_replaced: '로그 설명 치환 값',

    excel_filename: '잔액변동내역 {0}',
  },

  admin_main: {
    sign_out: '로그아웃',
    control_panel: '제어판',
    board: '게시판',
    member: '회원',
    login_list: '로그인 내역',
    trade: '거래소',
    b2c_list: 'B2C 주문내역',
    c2c_deal_list: 'C2C 매도 공시 내역',
    c2c_app_list: 'C2C 매수 요청 내역',
    transfer_list: '환전 내역',
    market: '시장',
    security: '보안',
    kyc_cdd: 'KYC 증명 요청(CDD)',
    kyc_real_name: 'KYC 실명 인증',
    kyc_withdraw: 'KYC 출금 주소(계좌) 인증',
    security_restriction: '보안 등급 및 제한 정책',
    finance: '금융',
    account: '계좌',
    deposit_list: '입금 내역',
    withdraw_list: '출금 내역',
    site: '사이트',
    lang: '다국어',
    setting: '설정',
    service: '서비스',
    mail: '메일',
    alert: '사건 알림',
    admin: '관리자',

    membership_group: '회원 그룹',
    OAuth2_client: 'OAuth2 클라이언트',
    activity_log: '활동 기록',
    cs_inquiry_history: 'CS 문의 내역',
    contract: '계약',
    pr_affiliate: '홍보, 제휴 및 중개',
    allowance_policy: '수당 정책',
    benefit_details: '수당 발생 및 시혜/수혜 내역',
    allowance_balance: '회원 자산별 수당 잔액',
    allowance_settlement: '수당 정산 내역',
    broker: '마스터',
    brokerage_balance: '마스터 잔액',
    brokers_equity: '마스터 지분 내역',
    brokerage_settlement: '마스터 정산 내역',
    payment_payment: '지불/결제',
    store: '상점',
    fee: '수수료',
    transaction_history: '거래 내역',
    asset_management: '자산 관리',
    plug_in: '자산 플러그인 관리',
    order_history: 'B2C 주문 내역',
    engagement_details: 'B2C 체결 내역',
    movement_history: 'B2C 자산 이동 내역',
    financial_management: '금융 및 자금 관리',
    transfer_details: '이체 내역',
    withdrawal_transmission_history: '출금 전송 내역',
    withdrawal_policy: '출금 정책',
    manageability_access_control: '관리 기능 접근 제어(ACS)',
    settlement_statistics: '정산 및 통계',
    phone: '전화',
  },
  admin_member_list: {
    member_list: '회원 목록',
    regdate: '가입일',
    detail: '상세보기',
    no_grade: '무등급',
    default: '기본',
    password_msg: '모사이트에서 수정 가능',
    nick_name: '닉네임',
    birthday: '생일',
    list: '목록으로',
    catalog: '회원정보',
    login_log: '로그인 기록',
    account: '보유 계좌',
  },
}
